import { render, staticRenderFns } from "./JjOrdinaryTable.vue?vue&type=template&id=21648476&scoped=true"
import script from "./JjOrdinaryTable.vue?vue&type=script&lang=js"
export * from "./JjOrdinaryTable.vue?vue&type=script&lang=js"
import style0 from "./JjOrdinaryTable.vue?vue&type=style&index=0&id=21648476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21648476",
  null
  
)

export default component.exports